import React from "react";
import { Modal, Button, Typography, Divider } from "antd";
import { useAIAssessmentContext } from "../../../../Context/AIAssessmentContext/AIAssessmentContext";
import { WarningOutlined } from "@ant-design/icons";
import useAiAssessmentStart from "../../hooks/useAiAssessmentStart";
import "./modals.scss";

const RightClickDisabledModal: React.FC = () => {
  const {
    showRightClickDisabledModal,
    setShowRightClickDisabledModal,
    fullscreenElementRef,
    isFullscreen,
    clearExitFullScreenState,
  } = useAIAssessmentContext();

  const { toggleToFullscreenMode } = useAiAssessmentStart();

  const handleClose = () => {
    setShowRightClickDisabledModal(false);
    if (!isFullscreen) {
      toggleToFullscreenMode();
    }
    clearExitFullScreenState();
  };
  return (
    <Modal
      keyboard={false}
      closeIcon={false}
      destroyOnClose={true}
      centered
      open={showRightClickDisabledModal}
      onCancel={handleClose}
      maskClosable={false}
      footer={null}
      getContainer={
        isFullscreen ? () => fullscreenElementRef.current! : undefined
      }
    >
      <div className="modal-content">
        <div className="modal-content-header">
          <Typography.Title level={5} style={{ margin: 0 }}>
            Right Click Disabled
          </Typography.Title>
        </div>
        <Divider style={{ margin: 0 }} />
        <div className="violation-modal-content-icon">
          <WarningOutlined />
        </div>

        <Typography.Text>
          Right click is disabled during the AI Assessment Rounds.
        </Typography.Text>
      </div>
      <div className="ai-assessment-modal-footer">
        <Button type="default" onClick={handleClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default RightClickDisabledModal;
